import "../App.css";
import React, { useState, useEffect, useMemo } from "react";
import { ConfigProvider, Spin } from "antd";
import AuthRoute from "./AuthRoute";
import AdminRoute from "./AdminRoute";

function AppRoutes() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const storedUserData = localStorage.getItem("user_data");
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      setIsLoggedIn(true);
      setUserData(parsedData);
    } else {
      setIsLoggedIn(false);
      setUserData(null);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      const disableNavigation = () => {
        window.location.href = window.location.href;
      };
      window.addEventListener("popstate", disableNavigation);
      return () => {
        window.removeEventListener("popstate", disableNavigation);
      };
    }
  }, [isLoggedIn]);

  const getActiveRoute = useMemo(() => {
    if (!userData) return null;
    switch (userData.data?.role) {
      case "admin":
      return <AdminRoute />;
      default:
        return null;
    }
  }, [userData]);

  if (isLoading) {
    return (
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Spin />
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#E11236",
        },
      }}
    >
      {isLoggedIn ? getActiveRoute : <AuthRoute />}
      
    </ConfigProvider>
  );
}

export default AppRoutes;
